import { Whatsapp } from '@transferwise/icons';
import PropTypes from 'prop-types';
import React from 'react';

import componentStyles from '../SocialSharing.module.less';

const generateLink = (details) => `https://api.whatsapp.com/send?text=${encodeURI(details.text)}`;

const generateOnClick = (onClickToShare, details) => {
  if (onClickToShare) {
    onClickToShare();
  }

  window.open(generateLink(details), '_blank');
};

const WhatsAppShareButton = ({ style, iconStyle, sharingDetails }) => (
  <button
    type="button"
    className={`${componentStyles['btn--circle']}`}
    style={style}
    onClick={() => {
      generateOnClick(sharingDetails.onClickToShare, sharingDetails);
    }}
  >
    <Whatsapp size={iconStyle.size} />
  </button>
);

WhatsAppShareButton.propTypes = {
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  iconStyle: PropTypes.shape({
    size: PropTypes.oneOf([16, 24]),
    className: PropTypes.string,
    title: PropTypes.string,
  }),
  sharingDetails: PropTypes.shape({
    text: PropTypes.string.isRequired,
    onClickToShare: PropTypes.func,
  }).isRequired,
};

WhatsAppShareButton.defaultProps = {
  style: {},
  iconStyle: {
    size: 24,
    className: '',
    title: '',
  },
};

export default WhatsAppShareButton;
